module.exports = __webpack_public_path__ + "static/ettercap_mtg_clb-5a1ac38f226137d26d40d4aaac5b1b14.webp";